import React from 'react'
import Grid from '@material-ui/core/Grid';

const Actions = (props) => {
  return (
    <div
      id="actions"
      style={{
        position: "absolute",
        color: "cyan",
        width: "100%",
        bottom: (props.bottom || 5) + "vh",
        fontSize: "5vh",
      }}
    >
      <Grid
        container
        spacing={1}
        justify="center"
        alignItems="center"
        style={{backgroundColor: "rgba(0, 0, 0, 0.6)"}}
      >
        {
          props.children.map((action) => (
            <Grid item>
              {(action)}
            </Grid>
          ))
        }
      </Grid>
    </div>
  )
}

export default Actions
